module.exports = __webpack_public_path__ + "img/fileJD.21c2a305.svg";